import withStyles, {
  createStyles,
  WithStyles,
} from 'raydiant-elements/core/withStyles';
import withThemeSelector from 'raydiant-elements/core/withThemeSelector';
import { Theme } from 'raydiant-elements/theme';
import * as React from 'react';

interface VideoProps extends WithStyles<typeof styles> {
  sources: Array<{ src: string; type: string }>;
  controls?: boolean;
  muted?: boolean;
  autoPlay?: boolean;
  loop?: boolean;
  playsInline?: boolean;
  backgroundColor?: string;
}

interface VideoState {}

class Video extends React.Component<VideoProps, VideoState> {
  static defaultProps: Partial<VideoProps> = {
    controls: false,
    muted: true,
    loop: false,
    autoPlay: true,
    playsInline: true,
  };

  state: VideoState = {};

  videoEl = React.createRef<HTMLVideoElement>();
  raf: number | null = null;

  componentDidMount() {
    const { autoPlay } = this.props;
    if (autoPlay) {
      this.playIfVisible();
      window.addEventListener('scroll', this.playIfVisible);
    }
  }

  playIfVisible = () => {
    if (!this.raf) {
      this.raf = requestAnimationFrame(() => {
        if (this.videoEl.current) {
          const bounds = this.videoEl.current.getBoundingClientRect();
          const windowInnerHeight = window.innerHeight;
          if (bounds.bottom < windowInnerHeight) {
            this.videoEl.current.play();
          }
        }
        this.raf = null;
      });
    }
  };

  render() {
    const {
      sources,
      controls = false,
      muted = true,
      loop = false,
      playsInline = true,
      backgroundColor,
      classes,
    } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.background} style={{ backgroundColor }} />
        <video
          ref={this.videoEl}
          className={classes.video}
          controls={controls}
          muted={muted}
          loop={loop}
          playsInline={playsInline}
        >
          {sources.map(({ src, type }, i) => (
            <source src={src} type={type} key={i} />
          ))}
        </video>
      </div>
    );
  }
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      position: 'relative',
      width: '100%',
      height: '100%',
    },
    video: {
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      objectFit: 'cover',

      [theme.breakpoints.down('xs')]: {
        maxHeight: 'none',
      },
    },
    background: {
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      backgroundColor: '#fff',
    },
  });

export default withThemeSelector(withStyles(styles)(Video), 'light');
